import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageClientWidth: 375,
    userId: '',
    deptId: '',
    localToken: '',
    roleId: ''
  },
  getters: {
  },
  mutations: {
    SET_USER_ID(state, id) {
      state.userId = id
    },
    SET_DEPT_ID(state, deptId) {
      state.deptId = deptId
    },
    SET_CLIENT_WIDTH(state, width) {
      state.pageClientWidth = width
    },
    SET_TOKEN(state, token) {
      state.localToken = token
    },
    SET_ROLE_ID(state, roleId) {
      state.roleId = roleId
    },
  },
  actions: {
  },
  modules: {
  }
})
